unit unit_Support;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, DB, WEBLib.WebCtrls;

type
  TSupport = class(TForm)
    TC: TTableControl;
    xdsTicket: TXDataWebDataSet;
    xdsTicketKundennummer: TXDataWebEntityField;
    xdsTicketProdukt: TXDataWebEntityField;
    xdsTicketKategorie: TXDataWebEntityField;
    xdsTicketPrioritaet: TXDataWebEntityField;
    xdsTicketStatus: TXDataWebEntityField;
    xdsTicketID: TIntegerField;
    xdsTicketErstelltAm: TDateTimeField;
    xdsTicketBetreff: TStringField;
    xdsTicketBeschreibung: TStringField;
    xdsTicketAbrechnungsbetrag: TFloatField;
    xdsTicketAbrechnungRechnungsnummer: TStringField;
    xdsTicketAberechnetAm: TDateTimeField;
    xdsTicketErledigtAm: TDateTimeField;
    xdsTicketNachname: TStringField;
    xdsTicketVorname: TStringField;
    xdsTicketEmail: TStringField;
    xdsTicketSystemInfo: TStringField;
    xdsTicketLoesung: TStringField;
    xdsTicketProtokoll: TStringField;
    xdsTicketZeitaufwandMinuten: TIntegerField;
    xdsTicketAbzurechnendeMinuten: TIntegerField;
    xdsTicketAbgerechneteMinuten: TIntegerField;
    xdsTicketBenachrichtigungNEU: TDateTimeField;
    xdsTicketBenachrichtigungLoesung: TDateTimeField;
    xdsTicketInterneBemerkung: TStringField;
    xdsTicketLoesungInfoSenden: TIntegerField;
    xdsTicketKontaktperson: TStringField;
    xdsTicketErreichbarkeitTelefon: TStringField;
    xdsTicketErreichbarkeitWann: TStringField;
    xdsProdukte: TXDataWebDataSet;
    xdsProdukteProdukt: TStringField;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenGruppeKunden: TBooleanField;
    xdsKundendatenGruppeLieferanten: TBooleanField;
    xdsKundendatenGruppeSonstige: TBooleanField;
    xdsKundendatenGruppeNichtkunden: TBooleanField;
    xdsKundendatenKontaktgruppe: TStringField;
    xdsKundendatenNachname: TStringField;
    xdsKundendatenVorname: TStringField;
    xdsKundendatenAdresszeile2: TStringField;
    xdsKundendatenAdresszeile3: TStringField;
    xdsKundendatenStrasse: TStringField;
    xdsKundendatenPostleitzahl: TStringField;
    xdsKundendatenOrt: TStringField;
    xdsKundendatenLaenderkuerzel: TStringField;
    xdsKundendatenLand: TStringField;
    xdsKundendatenLaenderkennzeichen: TBooleanField;
    xdsKundendatenAdressanrede: TStringField;
    xdsKundendatenBriefanrede1: TStringField;
    xdsKundendatenAdresseBild: TStringField;
    xdsKundendatenLieferanschrift: TStringField;
    xdsKundendatenTelefonNummer: TStringField;
    xdsKundendatenTelefaxNummer: TStringField;
    xdsKundendatenMobilTelefon: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenInternet: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenZahlungsbedingung: TIntegerField;
    xdsKundendatenTransportbedingung: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsKundendatenTelefonAlternativ: TStringField;
    xdsKundendatenTitel: TStringField;
    xdsKundendatenKundenklasseFarbe: TIntegerField;
    xdsKundendatenRechnungEmail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    xdsKundendatenBesteuerungKey: TIntegerField;
    xdsKundendatenAuftraegeJahr: TFloatField;
    xdsKundendatenAuftraegeVorjahr: TFloatField;
    xdsKundendatenLieferadresseID: TIntegerField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    xdsKundendatenKontaktverbund: TStringField;
    xdsKundendatenHinweis: TStringField;
    xdsKundendatenLatitude: TFloatField;
    xdsKundendatenLongitude: TFloatField;
    xdsKundendatenkmLuftlinie: TFloatField;
    xdsKundendatenGoogleID: TStringField;
    xdsKundendatenGoogleUpdatedUTC: TDateTimeField;
    xdsKundendatenBundesland: TStringField;
    xdsKundendatenRegion: TStringField;
    xdsKundendatenMandatsreferenz: TStringField;
    xdsKundendatenMandatsreferenzVom: TDateTimeField;
    xdsKundendatenLastschriftArt: TStringField;
    xdsKundendatenMahnsperre: TBooleanField;
    xdsKundendatenSuchbegriff: TStringField;
    xdsKundendatenLieferanschriftDaten: TStringField;
    xdsKundendatenExportKasse: TBooleanField;
    xdsKundendatenLoeschvormerkungDatum: TDateTimeField;
    xdsKundendatenLoeschvormerkungGrund: TStringField;
    xdsKundendatenPseudonymisiert: TStringField;
    xdsKundendatenLoginAktiv: TIntegerField;
    xdsKundendatenSonstigeDaten: TStringField;
    xdsStatus: TXDataWebDataSet;
    xdsStatusStatus: TStringField;
    xdsKategorie: TXDataWebDataSet;
    xdsKategorieKategorie: TStringField;
    xdsprioritaet: TXDataWebDataSet;
    xdsprioritaetPrioritaet: TIntegerField;
    xdsprioritaetPrioText: TStringField;
    xdsprioritaetPrioFarbe: TIntegerField;
    xdsTicketDateien: TXDataWebDataSet;
    xdsTicketDateienTicketID: TXDataWebEntityField;
    xdsTicketDateienID: TIntegerField;
    xdsTicketDateienDatumUhrzeit: TDateTimeField;
    xdsTicketDateienFuerLoesung: TIntegerField;
    xdsTicketDateienDateiMime: TStringField;
    xdsTicketDateienDateiName: TStringField;
    xdsTicketDateienDateiGroesse: TIntegerField;
    xdsTicketDateienDateiInhaltText: TStringField;
    xdsticket2: TXDataWebDataSet;
    XDataWebEntityField1: TXDataWebEntityField;
    XDataWebEntityField2: TXDataWebEntityField;
    XDataWebEntityField3: TXDataWebEntityField;
    XDataWebEntityField4: TXDataWebEntityField;
    XDataWebEntityField5: TXDataWebEntityField;
    IntegerField1: TIntegerField;
    DateTimeField1: TDateTimeField;
    StringField1: TStringField;
    StringField2: TStringField;
    FloatField1: TFloatField;
    StringField3: TStringField;
    DateTimeField2: TDateTimeField;
    DateTimeField3: TDateTimeField;
    StringField4: TStringField;
    StringField5: TStringField;
    StringField6: TStringField;
    StringField7: TStringField;
    StringField8: TStringField;
    StringField9: TStringField;
    IntegerField2: TIntegerField;
    IntegerField3: TIntegerField;
    IntegerField4: TIntegerField;
    DateTimeField4: TDateTimeField;
    DateTimeField5: TDateTimeField;
    StringField10: TStringField;
    IntegerField5: TIntegerField;
    StringField11: TStringField;
    StringField12: TStringField;
    StringField13: TStringField;
    WebFilePicker1: TFilePicker;
    WebFilePicker2: TFilePicker;
    WebFilePicker3: TFilePicker;
    xdsKontosaldo: TXDataWebDataSet;
    xdsKontosaldoKundennummer: TStringField;
    xdsKontosaldoZeitaufwand: TIntegerField;
    xdsKontosaldoAbzurechnen: TIntegerField;
    xdsKontosaldoGutschrift: TIntegerField;
    xdsKontosaldoAbzug: TIntegerField;
    xdsKontosaldoSaldo: TIntegerField;
    xdsKontosaldoBetrag: TFloatField;
    xdsKontosaldoMinutenpreis: TFloatField;
    xdsKontosaldoSRestguthaben: TIntegerField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsProdukteAfterOpen(DataSet: TDataSet);
    procedure xdsTicketAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsTicketAfterPost(DataSet: TDataSet);
    procedure xdsTicketAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsStatusAfterOpen(DataSet: TDataSet);
    procedure xdsKategorieAfterOpen(DataSet: TDataSet);
    procedure xdsprioritaetAfterOpen(DataSet: TDataSet);
    procedure WebFilePicker1GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure WebFilePicker2GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure WebFilePicker3GetFileAsBase64(Sender: TObject;
      AFileIndex: Integer; ABase64: string);
    procedure WebFilePicker1Change(Sender: TObject);
    procedure WebFilePicker2Change(Sender: TObject);
    procedure WebFilePicker3Change(Sender: TObject);
    procedure xdsKontosaldoAfterOpen(DataSet: TDataSet);
    procedure xdsTicketDateienAfterOpen(DataSet: TDataSet);
    procedure xdsticket2AfterOpen(DataSet: TDataSet);
    procedure xdsTicketDateienNewRecord(DataSet: TDataSet);
    procedure xdsTicketDateienAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnAbsenden:TButton;
    buttonzurueck:TButton;
    procedure btnAbsendenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure Formularaktualisieren;
    procedure uploadfilepickers;
  protected procedure LoadDFMValues; override; end;

var
  Support: TSupport;
  edtTicketGrund:TComboBox;
  edtBetreff:TEdit;
  edtBeschreibung:TMemo;
  edtKontaktperson:TEdit;
  edtTelefon:TEdit;
  edtWann:TEdit;
  edtSystemInfo:TMemo;
  file1base64str1:string;
  file1base64str2:string;
  file1base64str3:string;
implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TSupport.uploadfilepickers;
var
  hasnewrecord:boolean;
begin
  hasnewrecord:=false;
  if file1base64str1<>'' then
  begin
    xdsTicketDateien.Append();
    xdsTicketDateienTicketID.Value:=xdsticket2.CurrentData;
    xdsTicketDateienDatumUhrzeit.AsDateTime:=Date+time;
    xdsTicketDateienFuerLoesung.AsInteger:=0;
    xdsTicketDateienDateiMime.AsString:=WebFilePicker1.Files.Items[0].MimeType;
    xdsTicketDateienDateiGroesse.AsInteger:=WebFilePicker1.Files.Items[0].Size;
    xdsTicketDateienDateiName.AsString:=WebFilePicker1.Files.Items[0].Name;
    xdsTicketDateienDateiInhaltText.AsString:=file1base64str1;
    xdsTicketDateien.Post();
    hasnewrecord:=true;
  end;
  if file1base64str2<>'' then
  begin
    xdsTicketDateien.Append();
    xdsTicketDateienTicketID.Value:=xdsticket2.CurrentData;
    xdsTicketDateienDatumUhrzeit.AsDateTime:=Date+time;
    xdsTicketDateienFuerLoesung.AsInteger:=0;
    xdsTicketDateienDateiMime.AsString:=WebFilePicker2.Files.Items[0].MimeType;
    xdsTicketDateienDateiGroesse.AsInteger:=WebFilePicker2.Files.Items[0].Size;
    xdsTicketDateienDateiName.AsString:=WebFilePicker2.Files.Items[0].Name;
    xdsTicketDateienDateiInhaltText.AsString:=file1base64str2;
    xdsTicketDateien.Post();
    hasnewrecord:=true;
  end;
  if file1base64str3<>'' then
  begin
    xdsTicketDateien.Append();
    xdsTicketDateienTicketID.Value:=xdsticket2.CurrentData;
    xdsTicketDateienDatumUhrzeit.AsDateTime:=Date+time;
    xdsTicketDateienFuerLoesung.AsInteger:=0;
    xdsTicketDateienDateiMime.AsString:=WebFilePicker3.Files.Items[0].MimeType;
    xdsTicketDateienDateiGroesse.AsInteger:=WebFilePicker3.Files.Items[0].Size;
    xdsTicketDateienDateiName.AsString:=WebFilePicker3.Files.Items[0].Name;
    xdsTicketDateienDateiInhaltText.AsString:=file1base64str3;
    xdsTicketDateien.Post();
    hasnewrecord:=true;
  end;
  if hasnewrecord=true then
  begin
    xdsticketdateien.ApplyUpdates;
  end
  else
  begin
    showmessage('Ihr Ticket wurde erfolgreich erstellt. Über den Bearbeitsverlauf können Sie sich hier im Kundenportal unterrichtet halten.');
    close;
    Form1.btnSupportTicketsClick(nil);
  end;
end;

procedure TSupport.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TSupport.btnAbsendenClick(Sender: TObject);
begin
  if edtBetreff.Text='' then
  begin
    showmessage('Sie müssen einen Betreff eingeben');
    exit;
  end;
  if edtBeschreibung.Text='' then
  begin
    showmessage('Sie müssen eine Beschreibung eingeben');
    exit;
  end;
  if edtKontaktperson.Text='' then
  begin
    showmessage('Sie müssen eine Kontaktperson eingeben');
    exit;
  end;
  if edtTelefon.Text='' then
  begin
    showmessage('Sie müssen eine Telefonnummer eingeben');
    exit;
  end;
  if edtWann.Text='' then
  begin
    showmessage('Sie müssen die Erreichbarkeit eingeben');
    exit;
  end;
  if edtTicketGrund.Text='' then
  begin
    showmessage('Sie müssen einen Grund/Produkt auswählen');
    exit;
  end;
  xdsProdukte.Locate('Produkt',edtTicketGrund.Text,[]);

  xdsTicket.Append;
  xdsTicketKundennummer.Value:=xdsKundendaten.CurrentData;
  xdsTicketProdukt.Value:=xdsProdukte.CurrentData;
  xdsTicketStatus.Value:=xdsStatus.CurrentData;
  xdsTicketKategorie.Value:=xdsKategorie.CurrentData;
  xdsTicketPrioritaet.Value:=xdsprioritaet.CurrentData;
  xdsTicketErstelltAm.AsDateTime:=date+time;
  xdsTicketBetreff.AsString:=edtBetreff.Text;
  xdsTicketBeschreibung.AsString:=edtBeschreibung.Text;
  xdsTicketAbrechnungsbetrag.AsFloat:=0;
  xdsTicketSystemInfo.AsString:=edtSystemInfo.Text;
  xdsTicketZeitaufwandMinuten.AsInteger:=0;
  xdsTicketAbzurechnendeMinuten.AsInteger:=0;
  xdsTicketKontaktperson.AsString:=edtKontaktperson.Text;
  xdsTicketErreichbarkeitTelefon.AsString:=edtTelefon.Text;
  xdsTicketErreichbarkeitWann.AsString:=edtWann.Text;
  xdsTicketNachname.AsString:=xdsKundendatenNachname.AsString;
  xdsTicketVorname.AsString:=xdsKundendatenVorname.AsString;
  xdsTicketEmail.AsString:=xdsKundendatenEMail.AsString;
  xdsTicketProtokoll.AsString:=datetimetostr(date+time)+' NEU Kundenportal';
  xdsticket.Post;
end;

procedure TSupport.Formularaktualisieren;
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=1;
  tc.RowCount:=18;
  TC.Cells[0,i]:='<h4>Support';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  inc(i);

  tc.Cells[0,i]:='<h5>Willkommen in unserem Supportbereich';
  inc(i);
  tc.Cells[0,i]:='Hier fordern Sie persönliche Unterstützung durch unser Support-Team an.<br>';
  inc(i);
  tc.Cells[0,i]:='<p style="color:blue;">Sie verfügen über ein Supportguthaben von '+xdsKontosaldoSRestguthaben.Asstring+' Minuten';

  inc(i);
  tc.Cells[0,i]:='<h5>Erstellen Sie nachfolgend Ihr Ticket';
  inc(i);
  TC.Cells[0,i]:='Produkt auswählen*<br>';
  myelement:=TC.CellElements[0,i];
  edtTicketGrund:=TComboBox.Create(self);
  edtTicketGrund.ElementClassName:='form-control';
  edtTicketGrund.Width:=400;
  edtTicketGrund.HeightStyle:=ssAuto;
  edtTicketGrund.ItemIndex:=-1;
  edtTicketGrund.ParentElement:=myelement;
  edtTicketGrund.Items.Clear;
  xdsProdukte.First;
  while not xdsProdukte.eof do
  begin
    edtTicketGrund.Items.Add(xdsProdukteProdukt.AsString);
    xdsProdukte.Next;
  end;


  inc(i);
  TC.Cells[0,i]:='Betreff*<br>';
  myelement:=TC.CellElements[0,i];
  edtBetreff:=TEdit.Create(self);
  edtBetreff.ElementClassName:='form-control';
  edtBetreff.Width:=400;
  edtBetreff.HeightStyle:=ssAuto;
  edtBetreff.TextHint:='Betreff';
  edtBetreff.MaxLength:=100;
  edtBetreff.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Beschreibung*<br>';
  myelement:=TC.CellElements[0,i];
  edtBeschreibung:=TMemo.Create(self);
  edtBeschreibung.ElementClassName:='form-control';
  edtBeschreibung.WidthStyle:=ssAuto;
  edtBeschreibung.Height:=200;
  edtBeschreibung.HeightStyle:=ssAbsolute;
  edtBeschreibung.TextHint:='Beschreibung';
  edtBeschreibung.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Kontaktperson*<br>';
  myelement:=TC.CellElements[0,i];
  edtKontaktperson:=TEdit.Create(self);
  edtKontaktperson.ElementClassName:='form-control';
  edtKontaktperson.Width:=400;
  edtKontaktperson.HeightStyle:=ssAuto;
  edtKontaktperson.TextHint:='Ansprechpartner für diese Ticket';
  edtKontaktperson.MaxLength:=100;
  edtKontaktperson.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Ihre Telefonnummer*<br>';
  myelement:=TC.CellElements[0,i];
  edtTelefon:=TEdit.Create(self);
  edtTelefon.ElementClassName:='form-control';
  edtTelefon.Width:=400;
  edtTelefon.HeightStyle:=ssAuto;
  edtTelefon.TextHint:='Ansprechpartner Telefonnummer';
  edtTelefon.MaxLength:=100;
  edtTelefon.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Wann sind Sie erreichbar?*<br>';
  myelement:=TC.CellElements[0,i];
  edtWann:=TEdit.Create(self);
  edtWann.ElementClassName:='form-control';
  edtWann.Width:=400;
  edtWann.HeightStyle:=ssAuto;
  edtWann.TextHint:='Uhrzeit für Erreichbarkeit';
  edtWann.MaxLength:=100;
  edtWann.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Informationen zum Betriebssystem, Programmversions-Nr. und -Datum, andere hilfreiche Infos<br>';
  myelement:=TC.CellElements[0,i];
  edtSystemInfo:=TMemo.Create(self);
  edtSystemInfo.ElementClassName:='form-control';
  edtSystemInfo.WidthStyle:=ssAuto;
  edtSystemInfo.Height:=200;
  edtSystemInfo.HeightStyle:=ssAbsolute;
  edtSystemInfo.TextHint:='weitere Infos';
  edtSystemInfo.ParentElement:=myelement;
  inc(i);
  TC.Cells[0,i]:='Anlagen (max. 3 Dateien) JPG, JPEG, PNG, PDF, ZIP, TXT (max. 2 MB pro Datei) hinzufügen:';

  inc(i);
  myelement:=TC.cellelements[0,i];
  WebFilePicker1.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  WebFilePicker2.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  WebFilePicker3.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  btnAbsenden:=TButton.Create(self);
  btnAbsenden.ElementClassName:='btn btn-info text-left';
  btnAbsenden.HeightStyle:=ssauto;
  btnAbsenden.WidthStyle:=ssauto;
  btnAbsenden.tag:=0;
  btnAbsenden.Caption:='Absenden';
  btnAbsenden.OnClick:=@btnAbsendenClick;
  btnAbsenden.ParentElement:=myelement;

  buttonzurueck.setfocus;
end;

procedure TSupport.WebFilePicker1Change(Sender: TObject);
begin
  file1base64str1:='';
  if WebFilePicker1.Files.Count>0 then
  begin
    if WebFilePicker1.Files.Items[0].Size<2097153 then
    begin
      webfilepicker1.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TSupport.WebFilePicker1GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  file1base64str1:= 'data:' + WebFilePicker1.Files.Items[0].MimeType + ';base64,' + ABase64;
end;

procedure TSupport.WebFilePicker2Change(Sender: TObject);
begin
  file1base64str2:='';
  if WebFilePicker2.Files.Count>0 then
  begin
    if WebFilePicker2.Files.Items[0].Size<2097153 then
    begin
      webfilepicker2.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TSupport.WebFilePicker2GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  file1base64str2:= 'data:' + WebFilePicker2.Files.Items[0].MimeType + ';base64,' + ABase64;
end;

procedure TSupport.WebFilePicker3Change(Sender: TObject);
begin
  file1base64str3:='';
  if WebFilePicker3.Files.Count>0 then
  begin
    if WebFilePicker3.Files.Items[0].Size<2097153 then
    begin
      webfilepicker3.Files.Items[0].GetFileAsBase64;
    end
    else
    begin
      showmessage('Datei ist zu groß, bitte andere Datei wählen');
    end;
  end;
end;

procedure TSupport.WebFilePicker3GetFileAsBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  file1base64str3:= 'data:' + WebFilePicker3.Files.Items[0].MimeType + ';base64,' + ABase64;
end;

procedure TSupport.WebFormShow(Sender: TObject);
begin
  xdsKontosaldo.Close;
  xdsKontosaldo.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKontosaldo.Load;
end;

procedure TSupport.xdsKategorieAfterOpen(DataSet: TDataSet);
begin
  xdsKategorie.Locate('Kategorie','[-]',[]);
  xdsprioritaet.Load;
end;

procedure TSupport.xdsKontosaldoAfterOpen(DataSet: TDataSet);
begin
  xdsProdukte.Load;
end;

procedure TSupport.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  xdsStatus.Load;
end;

procedure TSupport.xdsprioritaetAfterOpen(DataSet: TDataSet);
begin
  xdsprioritaet.Locate('Prioritaet','3',[]);
  Formularaktualisieren;
end;

procedure TSupport.xdsProdukteAfterOpen(DataSet: TDataSet);
begin
  xdsTicket.Load;
end;

procedure TSupport.xdsStatusAfterOpen(DataSet: TDataSet);
begin
  xdsStatus.Locate('Status','ungelesen',[]);
  xdsKategorie.Load;
end;

procedure TSupport.xdsticket2AfterOpen(DataSet: TDataSet);
begin
  uploadfilepickers;
end;

procedure TSupport.xdsTicketAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    xdsticket2.Load;

  end;
end;

procedure TSupport.xdsTicketAfterOpen(DataSet: TDataSet);
begin
  xdsTicketDateien.Load;
end;

procedure TSupport.xdsTicketAfterPost(DataSet: TDataSet);
begin
  xdsTicket.ApplyUpdates;
end;

procedure TSupport.xdsTicketDateienAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    showmessage('Ihr Ticket wurde erfolgreich erstellt. Über den Bearbeitsverlauf können Sie sich hier im Kundenportal unterrichtet halten.');
    close;
    Form1.btnSupportTicketsClick(nil);
  end;

end;

procedure TSupport.xdsTicketDateienAfterOpen(DataSet: TDataSet);
begin
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;
end;

procedure TSupport.xdsTicketDateienNewRecord(DataSet: TDataSet);
begin
  xdsTicketDateienDatumUhrzeit.AsDateTime:=date+time;
  xdsTicketDateienFuerLoesung.AsInteger:=0;
  xdsTicketDateienTicketID.Value:=xdsTicket.CurrentData;
end;

procedure TSupport.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  WebFilePicker1 := TFilePicker.Create(Self);
  WebFilePicker2 := TFilePicker.Create(Self);
  WebFilePicker3 := TFilePicker.Create(Self);
  xdsTicket := TXDataWebDataSet.Create(Self);
  xdsTicketKundennummer := TXDataWebEntityField.Create(Self);
  xdsTicketProdukt := TXDataWebEntityField.Create(Self);
  xdsTicketKategorie := TXDataWebEntityField.Create(Self);
  xdsTicketPrioritaet := TXDataWebEntityField.Create(Self);
  xdsTicketStatus := TXDataWebEntityField.Create(Self);
  xdsTicketID := TIntegerField.Create(Self);
  xdsTicketErstelltAm := TDateTimeField.Create(Self);
  xdsTicketBetreff := TStringField.Create(Self);
  xdsTicketBeschreibung := TStringField.Create(Self);
  xdsTicketAbrechnungsbetrag := TFloatField.Create(Self);
  xdsTicketAbrechnungRechnungsnummer := TStringField.Create(Self);
  xdsTicketAberechnetAm := TDateTimeField.Create(Self);
  xdsTicketErledigtAm := TDateTimeField.Create(Self);
  xdsTicketNachname := TStringField.Create(Self);
  xdsTicketVorname := TStringField.Create(Self);
  xdsTicketEmail := TStringField.Create(Self);
  xdsTicketSystemInfo := TStringField.Create(Self);
  xdsTicketLoesung := TStringField.Create(Self);
  xdsTicketProtokoll := TStringField.Create(Self);
  xdsTicketZeitaufwandMinuten := TIntegerField.Create(Self);
  xdsTicketAbzurechnendeMinuten := TIntegerField.Create(Self);
  xdsTicketAbgerechneteMinuten := TIntegerField.Create(Self);
  xdsTicketBenachrichtigungNEU := TDateTimeField.Create(Self);
  xdsTicketBenachrichtigungLoesung := TDateTimeField.Create(Self);
  xdsTicketInterneBemerkung := TStringField.Create(Self);
  xdsTicketLoesungInfoSenden := TIntegerField.Create(Self);
  xdsTicketKontaktperson := TStringField.Create(Self);
  xdsTicketErreichbarkeitTelefon := TStringField.Create(Self);
  xdsTicketErreichbarkeitWann := TStringField.Create(Self);
  xdsProdukte := TXDataWebDataSet.Create(Self);
  xdsProdukteProdukt := TStringField.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenGruppeKunden := TBooleanField.Create(Self);
  xdsKundendatenGruppeLieferanten := TBooleanField.Create(Self);
  xdsKundendatenGruppeSonstige := TBooleanField.Create(Self);
  xdsKundendatenGruppeNichtkunden := TBooleanField.Create(Self);
  xdsKundendatenKontaktgruppe := TStringField.Create(Self);
  xdsKundendatenNachname := TStringField.Create(Self);
  xdsKundendatenVorname := TStringField.Create(Self);
  xdsKundendatenAdresszeile2 := TStringField.Create(Self);
  xdsKundendatenAdresszeile3 := TStringField.Create(Self);
  xdsKundendatenStrasse := TStringField.Create(Self);
  xdsKundendatenPostleitzahl := TStringField.Create(Self);
  xdsKundendatenOrt := TStringField.Create(Self);
  xdsKundendatenLaenderkuerzel := TStringField.Create(Self);
  xdsKundendatenLand := TStringField.Create(Self);
  xdsKundendatenLaenderkennzeichen := TBooleanField.Create(Self);
  xdsKundendatenAdressanrede := TStringField.Create(Self);
  xdsKundendatenBriefanrede1 := TStringField.Create(Self);
  xdsKundendatenAdresseBild := TStringField.Create(Self);
  xdsKundendatenLieferanschrift := TStringField.Create(Self);
  xdsKundendatenTelefonNummer := TStringField.Create(Self);
  xdsKundendatenTelefaxNummer := TStringField.Create(Self);
  xdsKundendatenMobilTelefon := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenInternet := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenZahlungsbedingung := TIntegerField.Create(Self);
  xdsKundendatenTransportbedingung := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsKundendatenTelefonAlternativ := TStringField.Create(Self);
  xdsKundendatenTitel := TStringField.Create(Self);
  xdsKundendatenKundenklasseFarbe := TIntegerField.Create(Self);
  xdsKundendatenRechnungEmail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);
  xdsKundendatenBesteuerungKey := TIntegerField.Create(Self);
  xdsKundendatenAuftraegeJahr := TFloatField.Create(Self);
  xdsKundendatenAuftraegeVorjahr := TFloatField.Create(Self);
  xdsKundendatenLieferadresseID := TIntegerField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsKundendatenKontaktverbund := TStringField.Create(Self);
  xdsKundendatenHinweis := TStringField.Create(Self);
  xdsKundendatenLatitude := TFloatField.Create(Self);
  xdsKundendatenLongitude := TFloatField.Create(Self);
  xdsKundendatenkmLuftlinie := TFloatField.Create(Self);
  xdsKundendatenGoogleID := TStringField.Create(Self);
  xdsKundendatenGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsKundendatenBundesland := TStringField.Create(Self);
  xdsKundendatenRegion := TStringField.Create(Self);
  xdsKundendatenMandatsreferenz := TStringField.Create(Self);
  xdsKundendatenMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsKundendatenLastschriftArt := TStringField.Create(Self);
  xdsKundendatenMahnsperre := TBooleanField.Create(Self);
  xdsKundendatenSuchbegriff := TStringField.Create(Self);
  xdsKundendatenLieferanschriftDaten := TStringField.Create(Self);
  xdsKundendatenExportKasse := TBooleanField.Create(Self);
  xdsKundendatenLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsKundendatenLoeschvormerkungGrund := TStringField.Create(Self);
  xdsKundendatenPseudonymisiert := TStringField.Create(Self);
  xdsKundendatenLoginAktiv := TIntegerField.Create(Self);
  xdsKundendatenSonstigeDaten := TStringField.Create(Self);
  xdsStatus := TXDataWebDataSet.Create(Self);
  xdsStatusStatus := TStringField.Create(Self);
  xdsKategorie := TXDataWebDataSet.Create(Self);
  xdsKategorieKategorie := TStringField.Create(Self);
  xdsprioritaet := TXDataWebDataSet.Create(Self);
  xdsprioritaetPrioritaet := TIntegerField.Create(Self);
  xdsprioritaetPrioText := TStringField.Create(Self);
  xdsprioritaetPrioFarbe := TIntegerField.Create(Self);
  xdsTicketDateien := TXDataWebDataSet.Create(Self);
  xdsTicketDateienTicketID := TXDataWebEntityField.Create(Self);
  xdsTicketDateienID := TIntegerField.Create(Self);
  xdsTicketDateienDatumUhrzeit := TDateTimeField.Create(Self);
  xdsTicketDateienFuerLoesung := TIntegerField.Create(Self);
  xdsTicketDateienDateiMime := TStringField.Create(Self);
  xdsTicketDateienDateiName := TStringField.Create(Self);
  xdsTicketDateienDateiGroesse := TIntegerField.Create(Self);
  xdsTicketDateienDateiInhaltText := TStringField.Create(Self);
  xdsticket2 := TXDataWebDataSet.Create(Self);
  XDataWebEntityField1 := TXDataWebEntityField.Create(Self);
  XDataWebEntityField2 := TXDataWebEntityField.Create(Self);
  XDataWebEntityField3 := TXDataWebEntityField.Create(Self);
  XDataWebEntityField4 := TXDataWebEntityField.Create(Self);
  XDataWebEntityField5 := TXDataWebEntityField.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  DateTimeField1 := TDateTimeField.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  FloatField1 := TFloatField.Create(Self);
  StringField3 := TStringField.Create(Self);
  DateTimeField2 := TDateTimeField.Create(Self);
  DateTimeField3 := TDateTimeField.Create(Self);
  StringField4 := TStringField.Create(Self);
  StringField5 := TStringField.Create(Self);
  StringField6 := TStringField.Create(Self);
  StringField7 := TStringField.Create(Self);
  StringField8 := TStringField.Create(Self);
  StringField9 := TStringField.Create(Self);
  IntegerField2 := TIntegerField.Create(Self);
  IntegerField3 := TIntegerField.Create(Self);
  IntegerField4 := TIntegerField.Create(Self);
  DateTimeField4 := TDateTimeField.Create(Self);
  DateTimeField5 := TDateTimeField.Create(Self);
  StringField10 := TStringField.Create(Self);
  IntegerField5 := TIntegerField.Create(Self);
  StringField11 := TStringField.Create(Self);
  StringField12 := TStringField.Create(Self);
  StringField13 := TStringField.Create(Self);
  xdsKontosaldo := TXDataWebDataSet.Create(Self);
  xdsKontosaldoKundennummer := TStringField.Create(Self);
  xdsKontosaldoZeitaufwand := TIntegerField.Create(Self);
  xdsKontosaldoAbzurechnen := TIntegerField.Create(Self);
  xdsKontosaldoGutschrift := TIntegerField.Create(Self);
  xdsKontosaldoAbzug := TIntegerField.Create(Self);
  xdsKontosaldoSaldo := TIntegerField.Create(Self);
  xdsKontosaldoBetrag := TFloatField.Create(Self);
  xdsKontosaldoMinutenpreis := TFloatField.Create(Self);
  xdsKontosaldoSRestguthaben := TIntegerField.Create(Self);

  TC.BeforeLoadDFMValues;
  WebFilePicker1.BeforeLoadDFMValues;
  WebFilePicker2.BeforeLoadDFMValues;
  WebFilePicker3.BeforeLoadDFMValues;
  xdsTicket.BeforeLoadDFMValues;
  xdsTicketKundennummer.BeforeLoadDFMValues;
  xdsTicketProdukt.BeforeLoadDFMValues;
  xdsTicketKategorie.BeforeLoadDFMValues;
  xdsTicketPrioritaet.BeforeLoadDFMValues;
  xdsTicketStatus.BeforeLoadDFMValues;
  xdsTicketID.BeforeLoadDFMValues;
  xdsTicketErstelltAm.BeforeLoadDFMValues;
  xdsTicketBetreff.BeforeLoadDFMValues;
  xdsTicketBeschreibung.BeforeLoadDFMValues;
  xdsTicketAbrechnungsbetrag.BeforeLoadDFMValues;
  xdsTicketAbrechnungRechnungsnummer.BeforeLoadDFMValues;
  xdsTicketAberechnetAm.BeforeLoadDFMValues;
  xdsTicketErledigtAm.BeforeLoadDFMValues;
  xdsTicketNachname.BeforeLoadDFMValues;
  xdsTicketVorname.BeforeLoadDFMValues;
  xdsTicketEmail.BeforeLoadDFMValues;
  xdsTicketSystemInfo.BeforeLoadDFMValues;
  xdsTicketLoesung.BeforeLoadDFMValues;
  xdsTicketProtokoll.BeforeLoadDFMValues;
  xdsTicketZeitaufwandMinuten.BeforeLoadDFMValues;
  xdsTicketAbzurechnendeMinuten.BeforeLoadDFMValues;
  xdsTicketAbgerechneteMinuten.BeforeLoadDFMValues;
  xdsTicketBenachrichtigungNEU.BeforeLoadDFMValues;
  xdsTicketBenachrichtigungLoesung.BeforeLoadDFMValues;
  xdsTicketInterneBemerkung.BeforeLoadDFMValues;
  xdsTicketLoesungInfoSenden.BeforeLoadDFMValues;
  xdsTicketKontaktperson.BeforeLoadDFMValues;
  xdsTicketErreichbarkeitTelefon.BeforeLoadDFMValues;
  xdsTicketErreichbarkeitWann.BeforeLoadDFMValues;
  xdsProdukte.BeforeLoadDFMValues;
  xdsProdukteProdukt.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenGruppeKunden.BeforeLoadDFMValues;
  xdsKundendatenGruppeLieferanten.BeforeLoadDFMValues;
  xdsKundendatenGruppeSonstige.BeforeLoadDFMValues;
  xdsKundendatenGruppeNichtkunden.BeforeLoadDFMValues;
  xdsKundendatenKontaktgruppe.BeforeLoadDFMValues;
  xdsKundendatenNachname.BeforeLoadDFMValues;
  xdsKundendatenVorname.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile2.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile3.BeforeLoadDFMValues;
  xdsKundendatenStrasse.BeforeLoadDFMValues;
  xdsKundendatenPostleitzahl.BeforeLoadDFMValues;
  xdsKundendatenOrt.BeforeLoadDFMValues;
  xdsKundendatenLaenderkuerzel.BeforeLoadDFMValues;
  xdsKundendatenLand.BeforeLoadDFMValues;
  xdsKundendatenLaenderkennzeichen.BeforeLoadDFMValues;
  xdsKundendatenAdressanrede.BeforeLoadDFMValues;
  xdsKundendatenBriefanrede1.BeforeLoadDFMValues;
  xdsKundendatenAdresseBild.BeforeLoadDFMValues;
  xdsKundendatenLieferanschrift.BeforeLoadDFMValues;
  xdsKundendatenTelefonNummer.BeforeLoadDFMValues;
  xdsKundendatenTelefaxNummer.BeforeLoadDFMValues;
  xdsKundendatenMobilTelefon.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenInternet.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenZahlungsbedingung.BeforeLoadDFMValues;
  xdsKundendatenTransportbedingung.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsKundendatenTelefonAlternativ.BeforeLoadDFMValues;
  xdsKundendatenTitel.BeforeLoadDFMValues;
  xdsKundendatenKundenklasseFarbe.BeforeLoadDFMValues;
  xdsKundendatenRechnungEmail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  xdsKundendatenBesteuerungKey.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeJahr.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsKundendatenLieferadresseID.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  xdsKundendatenKontaktverbund.BeforeLoadDFMValues;
  xdsKundendatenHinweis.BeforeLoadDFMValues;
  xdsKundendatenLatitude.BeforeLoadDFMValues;
  xdsKundendatenLongitude.BeforeLoadDFMValues;
  xdsKundendatenkmLuftlinie.BeforeLoadDFMValues;
  xdsKundendatenGoogleID.BeforeLoadDFMValues;
  xdsKundendatenGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsKundendatenBundesland.BeforeLoadDFMValues;
  xdsKundendatenRegion.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenz.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenzVom.BeforeLoadDFMValues;
  xdsKundendatenLastschriftArt.BeforeLoadDFMValues;
  xdsKundendatenMahnsperre.BeforeLoadDFMValues;
  xdsKundendatenSuchbegriff.BeforeLoadDFMValues;
  xdsKundendatenLieferanschriftDaten.BeforeLoadDFMValues;
  xdsKundendatenExportKasse.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsKundendatenPseudonymisiert.BeforeLoadDFMValues;
  xdsKundendatenLoginAktiv.BeforeLoadDFMValues;
  xdsKundendatenSonstigeDaten.BeforeLoadDFMValues;
  xdsStatus.BeforeLoadDFMValues;
  xdsStatusStatus.BeforeLoadDFMValues;
  xdsKategorie.BeforeLoadDFMValues;
  xdsKategorieKategorie.BeforeLoadDFMValues;
  xdsprioritaet.BeforeLoadDFMValues;
  xdsprioritaetPrioritaet.BeforeLoadDFMValues;
  xdsprioritaetPrioText.BeforeLoadDFMValues;
  xdsprioritaetPrioFarbe.BeforeLoadDFMValues;
  xdsTicketDateien.BeforeLoadDFMValues;
  xdsTicketDateienTicketID.BeforeLoadDFMValues;
  xdsTicketDateienID.BeforeLoadDFMValues;
  xdsTicketDateienDatumUhrzeit.BeforeLoadDFMValues;
  xdsTicketDateienFuerLoesung.BeforeLoadDFMValues;
  xdsTicketDateienDateiMime.BeforeLoadDFMValues;
  xdsTicketDateienDateiName.BeforeLoadDFMValues;
  xdsTicketDateienDateiGroesse.BeforeLoadDFMValues;
  xdsTicketDateienDateiInhaltText.BeforeLoadDFMValues;
  xdsticket2.BeforeLoadDFMValues;
  XDataWebEntityField1.BeforeLoadDFMValues;
  XDataWebEntityField2.BeforeLoadDFMValues;
  XDataWebEntityField3.BeforeLoadDFMValues;
  XDataWebEntityField4.BeforeLoadDFMValues;
  XDataWebEntityField5.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  DateTimeField1.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  FloatField1.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  DateTimeField2.BeforeLoadDFMValues;
  DateTimeField3.BeforeLoadDFMValues;
  StringField4.BeforeLoadDFMValues;
  StringField5.BeforeLoadDFMValues;
  StringField6.BeforeLoadDFMValues;
  StringField7.BeforeLoadDFMValues;
  StringField8.BeforeLoadDFMValues;
  StringField9.BeforeLoadDFMValues;
  IntegerField2.BeforeLoadDFMValues;
  IntegerField3.BeforeLoadDFMValues;
  IntegerField4.BeforeLoadDFMValues;
  DateTimeField4.BeforeLoadDFMValues;
  DateTimeField5.BeforeLoadDFMValues;
  StringField10.BeforeLoadDFMValues;
  IntegerField5.BeforeLoadDFMValues;
  StringField11.BeforeLoadDFMValues;
  StringField12.BeforeLoadDFMValues;
  StringField13.BeforeLoadDFMValues;
  xdsKontosaldo.BeforeLoadDFMValues;
  xdsKontosaldoKundennummer.BeforeLoadDFMValues;
  xdsKontosaldoZeitaufwand.BeforeLoadDFMValues;
  xdsKontosaldoAbzurechnen.BeforeLoadDFMValues;
  xdsKontosaldoGutschrift.BeforeLoadDFMValues;
  xdsKontosaldoAbzug.BeforeLoadDFMValues;
  xdsKontosaldoSaldo.BeforeLoadDFMValues;
  xdsKontosaldoBetrag.BeforeLoadDFMValues;
  xdsKontosaldoMinutenpreis.BeforeLoadDFMValues;
  xdsKontosaldoSRestguthaben.BeforeLoadDFMValues;
  try
    Name := 'Support';
    Width := 217;
    Height := 506;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 145;
    TC.Height := 297;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    WebFilePicker1.SetParentComponent(Self);
    WebFilePicker1.Name := 'WebFilePicker1';
    WebFilePicker1.Left := 32;
    WebFilePicker1.Top := 216;
    WebFilePicker1.Width := 129;
    WebFilePicker1.Height := 19;
    WebFilePicker1.ElementClassName := 'form-control';
    WebFilePicker1.HeightStyle := ssAuto;
    WebFilePicker1.WidthStyle := ssAuto;
    WebFilePicker1.Accept := '.jpg,.jpeg,.png,.txt,.pdf,.zip';
    WebFilePicker1.ChildOrder := 1;
    WebFilePicker1.ElementFont := efCSS;
    WebFilePicker1.ElementPosition := epIgnore;
    SetEvent(WebFilePicker1, Self, 'OnChange', 'WebFilePicker1Change');
    SetEvent(WebFilePicker1, Self, 'OnGetFileAsBase64', 'WebFilePicker1GetFileAsBase64');
    WebFilePicker2.SetParentComponent(Self);
    WebFilePicker2.Name := 'WebFilePicker2';
    WebFilePicker2.Left := 32;
    WebFilePicker2.Top := 241;
    WebFilePicker2.Width := 129;
    WebFilePicker2.Height := 19;
    WebFilePicker2.ElementClassName := 'form-control';
    WebFilePicker2.HeightStyle := ssAuto;
    WebFilePicker2.WidthStyle := ssAuto;
    WebFilePicker2.Accept := '.jpg,.jpeg,.png,.pdf,.txt';
    WebFilePicker2.ChildOrder := 1;
    WebFilePicker2.ElementFont := efCSS;
    WebFilePicker2.ElementPosition := epIgnore;
    SetEvent(WebFilePicker2, Self, 'OnChange', 'WebFilePicker2Change');
    SetEvent(WebFilePicker2, Self, 'OnGetFileAsBase64', 'WebFilePicker2GetFileAsBase64');
    WebFilePicker3.SetParentComponent(Self);
    WebFilePicker3.Name := 'WebFilePicker3';
    WebFilePicker3.Left := 32;
    WebFilePicker3.Top := 266;
    WebFilePicker3.Width := 129;
    WebFilePicker3.Height := 19;
    WebFilePicker3.ElementClassName := 'form-control';
    WebFilePicker3.HeightStyle := ssAuto;
    WebFilePicker3.WidthStyle := ssAuto;
    WebFilePicker3.Accept := '.jpg,.jpeg,.png,.pdf,.txt';
    WebFilePicker3.ChildOrder := 1;
    WebFilePicker3.ElementFont := efCSS;
    WebFilePicker3.ElementPosition := epIgnore;
    SetEvent(WebFilePicker3, Self, 'OnChange', 'WebFilePicker3Change');
    SetEvent(WebFilePicker3, Self, 'OnGetFileAsBase64', 'WebFilePicker3GetFileAsBase64');
    xdsTicket.SetParentComponent(Self);
    xdsTicket.Name := 'xdsTicket';
    xdsTicket.AfterApplyUpdates := xdsTicketAfterApplyUpdates;
    xdsTicket.AfterOpen := xdsTicketAfterOpen;
    xdsTicket.AfterPost := xdsTicketAfterPost;
    xdsTicket.EntitySetName := 'ITS_TicketMain';
    xdsTicket.Connection := DM2.XDataWebConnection1;
    xdsTicket.QueryTop := 1;
    xdsTicket.Left := 24;
    xdsTicket.Top := 288;
    xdsTicketKundennummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummer.Name := 'xdsTicketKundennummer';
    xdsTicketKundennummer.FieldName := 'Kundennummer';
    xdsTicketProdukt.SetParentComponent(xdsTicket);
    xdsTicketProdukt.Name := 'xdsTicketProdukt';
    xdsTicketProdukt.FieldName := 'Produkt';
    xdsTicketKategorie.SetParentComponent(xdsTicket);
    xdsTicketKategorie.Name := 'xdsTicketKategorie';
    xdsTicketKategorie.FieldName := 'Kategorie';
    xdsTicketPrioritaet.SetParentComponent(xdsTicket);
    xdsTicketPrioritaet.Name := 'xdsTicketPrioritaet';
    xdsTicketPrioritaet.FieldName := 'Prioritaet';
    xdsTicketStatus.SetParentComponent(xdsTicket);
    xdsTicketStatus.Name := 'xdsTicketStatus';
    xdsTicketStatus.FieldName := 'Status';
    xdsTicketID.SetParentComponent(xdsTicket);
    xdsTicketID.Name := 'xdsTicketID';
    xdsTicketID.FieldName := 'ID';
    xdsTicketErstelltAm.SetParentComponent(xdsTicket);
    xdsTicketErstelltAm.Name := 'xdsTicketErstelltAm';
    xdsTicketErstelltAm.FieldName := 'ErstelltAm';
    xdsTicketBetreff.SetParentComponent(xdsTicket);
    xdsTicketBetreff.Name := 'xdsTicketBetreff';
    xdsTicketBetreff.FieldName := 'Betreff';
    xdsTicketBetreff.Size := 100;
    xdsTicketBeschreibung.SetParentComponent(xdsTicket);
    xdsTicketBeschreibung.Name := 'xdsTicketBeschreibung';
    xdsTicketBeschreibung.FieldName := 'Beschreibung';
    xdsTicketBeschreibung.Size := 255;
    xdsTicketAbrechnungsbetrag.SetParentComponent(xdsTicket);
    xdsTicketAbrechnungsbetrag.Name := 'xdsTicketAbrechnungsbetrag';
    xdsTicketAbrechnungsbetrag.FieldName := 'Abrechnungsbetrag';
    xdsTicketAbrechnungRechnungsnummer.SetParentComponent(xdsTicket);
    xdsTicketAbrechnungRechnungsnummer.Name := 'xdsTicketAbrechnungRechnungsnummer';
    xdsTicketAbrechnungRechnungsnummer.FieldName := 'AbrechnungRechnungsnummer';
    xdsTicketAbrechnungRechnungsnummer.Size := 10;
    xdsTicketAberechnetAm.SetParentComponent(xdsTicket);
    xdsTicketAberechnetAm.Name := 'xdsTicketAberechnetAm';
    xdsTicketAberechnetAm.FieldName := 'AberechnetAm';
    xdsTicketErledigtAm.SetParentComponent(xdsTicket);
    xdsTicketErledigtAm.Name := 'xdsTicketErledigtAm';
    xdsTicketErledigtAm.FieldName := 'ErledigtAm';
    xdsTicketNachname.SetParentComponent(xdsTicket);
    xdsTicketNachname.Name := 'xdsTicketNachname';
    xdsTicketNachname.FieldName := 'Nachname';
    xdsTicketNachname.Size := 40;
    xdsTicketVorname.SetParentComponent(xdsTicket);
    xdsTicketVorname.Name := 'xdsTicketVorname';
    xdsTicketVorname.FieldName := 'Vorname';
    xdsTicketVorname.Size := 40;
    xdsTicketEmail.SetParentComponent(xdsTicket);
    xdsTicketEmail.Name := 'xdsTicketEmail';
    xdsTicketEmail.FieldName := 'Email';
    xdsTicketEmail.Size := 50;
    xdsTicketSystemInfo.SetParentComponent(xdsTicket);
    xdsTicketSystemInfo.Name := 'xdsTicketSystemInfo';
    xdsTicketSystemInfo.FieldName := 'SystemInfo';
    xdsTicketSystemInfo.Size := 255;
    xdsTicketLoesung.SetParentComponent(xdsTicket);
    xdsTicketLoesung.Name := 'xdsTicketLoesung';
    xdsTicketLoesung.FieldName := 'Loesung';
    xdsTicketLoesung.Size := 255;
    xdsTicketProtokoll.SetParentComponent(xdsTicket);
    xdsTicketProtokoll.Name := 'xdsTicketProtokoll';
    xdsTicketProtokoll.FieldName := 'Protokoll';
    xdsTicketProtokoll.Size := 255;
    xdsTicketZeitaufwandMinuten.SetParentComponent(xdsTicket);
    xdsTicketZeitaufwandMinuten.Name := 'xdsTicketZeitaufwandMinuten';
    xdsTicketZeitaufwandMinuten.FieldName := 'ZeitaufwandMinuten';
    xdsTicketAbzurechnendeMinuten.SetParentComponent(xdsTicket);
    xdsTicketAbzurechnendeMinuten.Name := 'xdsTicketAbzurechnendeMinuten';
    xdsTicketAbzurechnendeMinuten.FieldName := 'AbzurechnendeMinuten';
    xdsTicketAbgerechneteMinuten.SetParentComponent(xdsTicket);
    xdsTicketAbgerechneteMinuten.Name := 'xdsTicketAbgerechneteMinuten';
    xdsTicketAbgerechneteMinuten.FieldName := 'AbgerechneteMinuten';
    xdsTicketBenachrichtigungNEU.SetParentComponent(xdsTicket);
    xdsTicketBenachrichtigungNEU.Name := 'xdsTicketBenachrichtigungNEU';
    xdsTicketBenachrichtigungNEU.FieldName := 'BenachrichtigungNEU';
    xdsTicketBenachrichtigungLoesung.SetParentComponent(xdsTicket);
    xdsTicketBenachrichtigungLoesung.Name := 'xdsTicketBenachrichtigungLoesung';
    xdsTicketBenachrichtigungLoesung.FieldName := 'BenachrichtigungLoesung';
    xdsTicketInterneBemerkung.SetParentComponent(xdsTicket);
    xdsTicketInterneBemerkung.Name := 'xdsTicketInterneBemerkung';
    xdsTicketInterneBemerkung.FieldName := 'InterneBemerkung';
    xdsTicketInterneBemerkung.Size := 255;
    xdsTicketLoesungInfoSenden.SetParentComponent(xdsTicket);
    xdsTicketLoesungInfoSenden.Name := 'xdsTicketLoesungInfoSenden';
    xdsTicketLoesungInfoSenden.FieldName := 'LoesungInfoSenden';
    xdsTicketKontaktperson.SetParentComponent(xdsTicket);
    xdsTicketKontaktperson.Name := 'xdsTicketKontaktperson';
    xdsTicketKontaktperson.FieldName := 'Kontaktperson';
    xdsTicketKontaktperson.Size := 100;
    xdsTicketErreichbarkeitTelefon.SetParentComponent(xdsTicket);
    xdsTicketErreichbarkeitTelefon.Name := 'xdsTicketErreichbarkeitTelefon';
    xdsTicketErreichbarkeitTelefon.FieldName := 'ErreichbarkeitTelefon';
    xdsTicketErreichbarkeitTelefon.Size := 100;
    xdsTicketErreichbarkeitWann.SetParentComponent(xdsTicket);
    xdsTicketErreichbarkeitWann.Name := 'xdsTicketErreichbarkeitWann';
    xdsTicketErreichbarkeitWann.FieldName := 'ErreichbarkeitWann';
    xdsTicketErreichbarkeitWann.Size := 100;
    xdsProdukte.SetParentComponent(Self);
    xdsProdukte.Name := 'xdsProdukte';
    xdsProdukte.AfterOpen := xdsProdukteAfterOpen;
    xdsProdukte.EntitySetName := 'ITS_Produkte';
    xdsProdukte.Connection := DM2.XDataWebConnection1;
    xdsProdukte.Left := 16;
    xdsProdukte.Top := 344;
    xdsProdukteProdukt.SetParentComponent(xdsProdukte);
    xdsProdukteProdukt.Name := 'xdsProdukteProdukt';
    xdsProdukteProdukt.FieldName := 'Produkt';
    xdsProdukteProdukt.Required := True;
    xdsProdukteProdukt.Size := 50;
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 32;
    xdsKundendaten.Top := 232;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Required := True;
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenGruppeKunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeKunden.Name := 'xdsKundendatenGruppeKunden';
    xdsKundendatenGruppeKunden.FieldName := 'GruppeKunden';
    xdsKundendatenGruppeLieferanten.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeLieferanten.Name := 'xdsKundendatenGruppeLieferanten';
    xdsKundendatenGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsKundendatenGruppeSonstige.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeSonstige.Name := 'xdsKundendatenGruppeSonstige';
    xdsKundendatenGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsKundendatenGruppeNichtkunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeNichtkunden.Name := 'xdsKundendatenGruppeNichtkunden';
    xdsKundendatenGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsKundendatenKontaktgruppe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktgruppe.Name := 'xdsKundendatenKontaktgruppe';
    xdsKundendatenKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsKundendatenKontaktgruppe.Size := 50;
    xdsKundendatenNachname.SetParentComponent(xdsKundendaten);
    xdsKundendatenNachname.Name := 'xdsKundendatenNachname';
    xdsKundendatenNachname.FieldName := 'Nachname';
    xdsKundendatenNachname.Size := 40;
    xdsKundendatenVorname.SetParentComponent(xdsKundendaten);
    xdsKundendatenVorname.Name := 'xdsKundendatenVorname';
    xdsKundendatenVorname.FieldName := 'Vorname';
    xdsKundendatenVorname.Size := 40;
    xdsKundendatenAdresszeile2.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile2.Name := 'xdsKundendatenAdresszeile2';
    xdsKundendatenAdresszeile2.FieldName := 'Adresszeile2';
    xdsKundendatenAdresszeile2.Size := 40;
    xdsKundendatenAdresszeile3.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile3.Name := 'xdsKundendatenAdresszeile3';
    xdsKundendatenAdresszeile3.FieldName := 'Adresszeile3';
    xdsKundendatenAdresszeile3.Size := 40;
    xdsKundendatenStrasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenStrasse.Name := 'xdsKundendatenStrasse';
    xdsKundendatenStrasse.FieldName := 'Strasse';
    xdsKundendatenStrasse.Size := 40;
    xdsKundendatenPostleitzahl.SetParentComponent(xdsKundendaten);
    xdsKundendatenPostleitzahl.Name := 'xdsKundendatenPostleitzahl';
    xdsKundendatenPostleitzahl.FieldName := 'Postleitzahl';
    xdsKundendatenPostleitzahl.Size := 6;
    xdsKundendatenOrt.SetParentComponent(xdsKundendaten);
    xdsKundendatenOrt.Name := 'xdsKundendatenOrt';
    xdsKundendatenOrt.FieldName := 'Ort';
    xdsKundendatenOrt.Size := 40;
    xdsKundendatenLaenderkuerzel.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkuerzel.Name := 'xdsKundendatenLaenderkuerzel';
    xdsKundendatenLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKundendatenLaenderkuerzel.Size := 5;
    xdsKundendatenLand.SetParentComponent(xdsKundendaten);
    xdsKundendatenLand.Name := 'xdsKundendatenLand';
    xdsKundendatenLand.FieldName := 'Land';
    xdsKundendatenLand.Size := 40;
    xdsKundendatenLaenderkennzeichen.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkennzeichen.Name := 'xdsKundendatenLaenderkennzeichen';
    xdsKundendatenLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsKundendatenAdressanrede.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdressanrede.Name := 'xdsKundendatenAdressanrede';
    xdsKundendatenAdressanrede.FieldName := 'Adressanrede';
    xdsKundendatenAdressanrede.Size := 15;
    xdsKundendatenBriefanrede1.SetParentComponent(xdsKundendaten);
    xdsKundendatenBriefanrede1.Name := 'xdsKundendatenBriefanrede1';
    xdsKundendatenBriefanrede1.FieldName := 'Briefanrede1';
    xdsKundendatenBriefanrede1.Size := 255;
    xdsKundendatenAdresseBild.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresseBild.Name := 'xdsKundendatenAdresseBild';
    xdsKundendatenAdresseBild.FieldName := 'AdresseBild';
    xdsKundendatenAdresseBild.Size := 255;
    xdsKundendatenLieferanschrift.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschrift.Name := 'xdsKundendatenLieferanschrift';
    xdsKundendatenLieferanschrift.FieldName := 'Lieferanschrift';
    xdsKundendatenLieferanschrift.Size := 255;
    xdsKundendatenTelefonNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonNummer.Name := 'xdsKundendatenTelefonNummer';
    xdsKundendatenTelefonNummer.FieldName := 'TelefonNummer';
    xdsKundendatenTelefonNummer.Size := 25;
    xdsKundendatenTelefaxNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefaxNummer.Name := 'xdsKundendatenTelefaxNummer';
    xdsKundendatenTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKundendatenTelefaxNummer.Size := 25;
    xdsKundendatenMobilTelefon.SetParentComponent(xdsKundendaten);
    xdsKundendatenMobilTelefon.Name := 'xdsKundendatenMobilTelefon';
    xdsKundendatenMobilTelefon.FieldName := 'MobilTelefon';
    xdsKundendatenMobilTelefon.Size := 25;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenInternet.SetParentComponent(xdsKundendaten);
    xdsKundendatenInternet.Name := 'xdsKundendatenInternet';
    xdsKundendatenInternet.FieldName := 'Internet';
    xdsKundendatenInternet.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenZahlungsbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenZahlungsbedingung.Name := 'xdsKundendatenZahlungsbedingung';
    xdsKundendatenZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsKundendatenTransportbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenTransportbedingung.Name := 'xdsKundendatenTransportbedingung';
    xdsKundendatenTransportbedingung.FieldName := 'Transportbedingung';
    xdsKundendatenTransportbedingung.Size := 100;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKundendatenTelefonAlternativ.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonAlternativ.Name := 'xdsKundendatenTelefonAlternativ';
    xdsKundendatenTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKundendatenTelefonAlternativ.Size := 50;
    xdsKundendatenTitel.SetParentComponent(xdsKundendaten);
    xdsKundendatenTitel.Name := 'xdsKundendatenTitel';
    xdsKundendatenTitel.FieldName := 'Titel';
    xdsKundendatenKundenklasseFarbe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundenklasseFarbe.Name := 'xdsKundendatenKundenklasseFarbe';
    xdsKundendatenKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsKundendatenRechnungEmail.SetParentComponent(xdsKundendaten);
    xdsKundendatenRechnungEmail.Name := 'xdsKundendatenRechnungEmail';
    xdsKundendatenRechnungEmail.FieldName := 'RechnungEmail';
    xdsKundendatenRechnungEmail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
    xdsKundendatenBesteuerungKey.SetParentComponent(xdsKundendaten);
    xdsKundendatenBesteuerungKey.Name := 'xdsKundendatenBesteuerungKey';
    xdsKundendatenBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsKundendatenAuftraegeJahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeJahr.Name := 'xdsKundendatenAuftraegeJahr';
    xdsKundendatenAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsKundendatenAuftraegeVorjahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeVorjahr.Name := 'xdsKundendatenAuftraegeVorjahr';
    xdsKundendatenAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsKundendatenLieferadresseID.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferadresseID.Name := 'xdsKundendatenLieferadresseID';
    xdsKundendatenLieferadresseID.FieldName := 'LieferadresseID';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsKundendatenKontaktverbund.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktverbund.Name := 'xdsKundendatenKontaktverbund';
    xdsKundendatenKontaktverbund.FieldName := 'Kontaktverbund';
    xdsKundendatenKontaktverbund.Size := 25;
    xdsKundendatenHinweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenHinweis.Name := 'xdsKundendatenHinweis';
    xdsKundendatenHinweis.FieldName := 'Hinweis';
    xdsKundendatenHinweis.Size := 255;
    xdsKundendatenLatitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLatitude.Name := 'xdsKundendatenLatitude';
    xdsKundendatenLatitude.FieldName := 'Latitude';
    xdsKundendatenLongitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLongitude.Name := 'xdsKundendatenLongitude';
    xdsKundendatenLongitude.FieldName := 'Longitude';
    xdsKundendatenkmLuftlinie.SetParentComponent(xdsKundendaten);
    xdsKundendatenkmLuftlinie.Name := 'xdsKundendatenkmLuftlinie';
    xdsKundendatenkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsKundendatenGoogleID.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleID.Name := 'xdsKundendatenGoogleID';
    xdsKundendatenGoogleID.FieldName := 'GoogleID';
    xdsKundendatenGoogleID.Size := 50;
    xdsKundendatenGoogleUpdatedUTC.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleUpdatedUTC.Name := 'xdsKundendatenGoogleUpdatedUTC';
    xdsKundendatenGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsKundendatenBundesland.SetParentComponent(xdsKundendaten);
    xdsKundendatenBundesland.Name := 'xdsKundendatenBundesland';
    xdsKundendatenBundesland.FieldName := 'Bundesland';
    xdsKundendatenBundesland.Size := 50;
    xdsKundendatenRegion.SetParentComponent(xdsKundendaten);
    xdsKundendatenRegion.Name := 'xdsKundendatenRegion';
    xdsKundendatenRegion.FieldName := 'Region';
    xdsKundendatenRegion.Size := 50;
    xdsKundendatenMandatsreferenz.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenz.Name := 'xdsKundendatenMandatsreferenz';
    xdsKundendatenMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsKundendatenMandatsreferenz.Size := 34;
    xdsKundendatenMandatsreferenzVom.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenzVom.Name := 'xdsKundendatenMandatsreferenzVom';
    xdsKundendatenMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsKundendatenLastschriftArt.SetParentComponent(xdsKundendaten);
    xdsKundendatenLastschriftArt.Name := 'xdsKundendatenLastschriftArt';
    xdsKundendatenLastschriftArt.FieldName := 'LastschriftArt';
    xdsKundendatenLastschriftArt.Size := 2;
    xdsKundendatenMahnsperre.SetParentComponent(xdsKundendaten);
    xdsKundendatenMahnsperre.Name := 'xdsKundendatenMahnsperre';
    xdsKundendatenMahnsperre.FieldName := 'Mahnsperre';
    xdsKundendatenSuchbegriff.SetParentComponent(xdsKundendaten);
    xdsKundendatenSuchbegriff.Name := 'xdsKundendatenSuchbegriff';
    xdsKundendatenSuchbegriff.FieldName := 'Suchbegriff';
    xdsKundendatenSuchbegriff.Size := 25;
    xdsKundendatenLieferanschriftDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschriftDaten.Name := 'xdsKundendatenLieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.Size := 255;
    xdsKundendatenExportKasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenExportKasse.Name := 'xdsKundendatenExportKasse';
    xdsKundendatenExportKasse.FieldName := 'ExportKasse';
    xdsKundendatenLoeschvormerkungDatum.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungDatum.Name := 'xdsKundendatenLoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungGrund.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungGrund.Name := 'xdsKundendatenLoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.Size := 250;
    xdsKundendatenPseudonymisiert.SetParentComponent(xdsKundendaten);
    xdsKundendatenPseudonymisiert.Name := 'xdsKundendatenPseudonymisiert';
    xdsKundendatenPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsKundendatenPseudonymisiert.Size := 255;
    xdsKundendatenLoginAktiv.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginAktiv.Name := 'xdsKundendatenLoginAktiv';
    xdsKundendatenLoginAktiv.FieldName := 'LoginAktiv';
    xdsKundendatenSonstigeDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenSonstigeDaten.Name := 'xdsKundendatenSonstigeDaten';
    xdsKundendatenSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsKundendatenSonstigeDaten.Size := 255;
    xdsStatus.SetParentComponent(Self);
    xdsStatus.Name := 'xdsStatus';
    xdsStatus.AfterOpen := xdsStatusAfterOpen;
    xdsStatus.EntitySetName := 'ITS_TicketStatus';
    xdsStatus.Connection := DM2.XDataWebConnection1;
    xdsStatus.Left := 32;
    xdsStatus.Top := 168;
    xdsStatusStatus.SetParentComponent(xdsStatus);
    xdsStatusStatus.Name := 'xdsStatusStatus';
    xdsStatusStatus.FieldName := 'Status';
    xdsStatusStatus.Required := True;
    xdsStatusStatus.Size := 25;
    xdsKategorie.SetParentComponent(Self);
    xdsKategorie.Name := 'xdsKategorie';
    xdsKategorie.AfterOpen := xdsKategorieAfterOpen;
    xdsKategorie.EntitySetName := 'ITS_TicketKategorie';
    xdsKategorie.Connection := DM2.XDataWebConnection1;
    xdsKategorie.Left := 32;
    xdsKategorie.Top := 112;
    xdsKategorieKategorie.SetParentComponent(xdsKategorie);
    xdsKategorieKategorie.Name := 'xdsKategorieKategorie';
    xdsKategorieKategorie.FieldName := 'Kategorie';
    xdsKategorieKategorie.Required := True;
    xdsKategorieKategorie.Size := 25;
    xdsprioritaet.SetParentComponent(Self);
    xdsprioritaet.Name := 'xdsprioritaet';
    xdsprioritaet.AfterOpen := xdsprioritaetAfterOpen;
    xdsprioritaet.EntitySetName := 'ITS_TicketPrioritaet';
    xdsprioritaet.Connection := DM2.XDataWebConnection1;
    xdsprioritaet.QueryString := '$filter=Prioritaet gt 0';
    xdsprioritaet.Left := 32;
    xdsprioritaet.Top := 56;
    xdsprioritaetPrioritaet.SetParentComponent(xdsprioritaet);
    xdsprioritaetPrioritaet.Name := 'xdsprioritaetPrioritaet';
    xdsprioritaetPrioritaet.FieldName := 'Prioritaet';
    xdsprioritaetPrioritaet.Required := True;
    xdsprioritaetPrioText.SetParentComponent(xdsprioritaet);
    xdsprioritaetPrioText.Name := 'xdsprioritaetPrioText';
    xdsprioritaetPrioText.FieldName := 'PrioText';
    xdsprioritaetPrioFarbe.SetParentComponent(xdsprioritaet);
    xdsprioritaetPrioFarbe.Name := 'xdsprioritaetPrioFarbe';
    xdsprioritaetPrioFarbe.FieldName := 'PrioFarbe';
    xdsTicketDateien.SetParentComponent(Self);
    xdsTicketDateien.Name := 'xdsTicketDateien';
    xdsTicketDateien.AfterApplyUpdates := xdsTicketDateienAfterApplyUpdates;
    xdsTicketDateien.AfterOpen := xdsTicketDateienAfterOpen;
    SetEvent(xdsTicketDateien, Self, 'OnNewRecord', 'xdsTicketDateienNewRecord');
    xdsTicketDateien.EntitySetName := 'ITS_TicketDateien';
    xdsTicketDateien.Connection := DM2.XDataWebConnection1;
    xdsTicketDateien.QueryTop := 1;
    xdsTicketDateien.Left := 128;
    xdsTicketDateien.Top := 56;
    xdsTicketDateienTicketID.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienTicketID.Name := 'xdsTicketDateienTicketID';
    xdsTicketDateienTicketID.FieldName := 'TicketID';
    xdsTicketDateienID.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienID.Name := 'xdsTicketDateienID';
    xdsTicketDateienID.FieldName := 'ID';
    xdsTicketDateienDatumUhrzeit.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDatumUhrzeit.Name := 'xdsTicketDateienDatumUhrzeit';
    xdsTicketDateienDatumUhrzeit.FieldName := 'DatumUhrzeit';
    xdsTicketDateienFuerLoesung.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienFuerLoesung.Name := 'xdsTicketDateienFuerLoesung';
    xdsTicketDateienFuerLoesung.FieldName := 'FuerLoesung';
    xdsTicketDateienDateiMime.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiMime.Name := 'xdsTicketDateienDateiMime';
    xdsTicketDateienDateiMime.FieldName := 'DateiMime';
    xdsTicketDateienDateiMime.Size := 50;
    xdsTicketDateienDateiName.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiName.Name := 'xdsTicketDateienDateiName';
    xdsTicketDateienDateiName.FieldName := 'DateiName';
    xdsTicketDateienDateiName.Size := 255;
    xdsTicketDateienDateiGroesse.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiGroesse.Name := 'xdsTicketDateienDateiGroesse';
    xdsTicketDateienDateiGroesse.FieldName := 'DateiGroesse';
    xdsTicketDateienDateiInhaltText.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiInhaltText.Name := 'xdsTicketDateienDateiInhaltText';
    xdsTicketDateienDateiInhaltText.FieldName := 'DateiInhaltText';
    xdsTicketDateienDateiInhaltText.Size := 255;
    xdsticket2.SetParentComponent(Self);
    xdsticket2.Name := 'xdsticket2';
    xdsticket2.AfterOpen := xdsticket2AfterOpen;
    xdsticket2.EntitySetName := 'ITS_TicketMain';
    xdsticket2.Connection := DM2.XDataWebConnection1;
    xdsticket2.QueryString := '$orderby=ID DESC';
    xdsticket2.QueryTop := 1;
    xdsticket2.Left := 128;
    xdsticket2.Top := 312;
    XDataWebEntityField1.SetParentComponent(xdsticket2);
    XDataWebEntityField1.Name := 'XDataWebEntityField1';
    XDataWebEntityField1.FieldName := 'Kundennummer';
    XDataWebEntityField2.SetParentComponent(xdsticket2);
    XDataWebEntityField2.Name := 'XDataWebEntityField2';
    XDataWebEntityField2.FieldName := 'Produkt';
    XDataWebEntityField3.SetParentComponent(xdsticket2);
    XDataWebEntityField3.Name := 'XDataWebEntityField3';
    XDataWebEntityField3.FieldName := 'Kategorie';
    XDataWebEntityField4.SetParentComponent(xdsticket2);
    XDataWebEntityField4.Name := 'XDataWebEntityField4';
    XDataWebEntityField4.FieldName := 'Prioritaet';
    XDataWebEntityField5.SetParentComponent(xdsticket2);
    XDataWebEntityField5.Name := 'XDataWebEntityField5';
    XDataWebEntityField5.FieldName := 'Status';
    IntegerField1.SetParentComponent(xdsticket2);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'ID';
    DateTimeField1.SetParentComponent(xdsticket2);
    DateTimeField1.Name := 'DateTimeField1';
    DateTimeField1.FieldName := 'ErstelltAm';
    StringField1.SetParentComponent(xdsticket2);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Betreff';
    StringField1.Size := 100;
    StringField2.SetParentComponent(xdsticket2);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'Beschreibung';
    StringField2.Size := 255;
    FloatField1.SetParentComponent(xdsticket2);
    FloatField1.Name := 'FloatField1';
    FloatField1.FieldName := 'Abrechnungsbetrag';
    StringField3.SetParentComponent(xdsticket2);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'AbrechnungRechnungsnummer';
    StringField3.Size := 10;
    DateTimeField2.SetParentComponent(xdsticket2);
    DateTimeField2.Name := 'DateTimeField2';
    DateTimeField2.FieldName := 'AberechnetAm';
    DateTimeField3.SetParentComponent(xdsticket2);
    DateTimeField3.Name := 'DateTimeField3';
    DateTimeField3.FieldName := 'ErledigtAm';
    StringField4.SetParentComponent(xdsticket2);
    StringField4.Name := 'StringField4';
    StringField4.FieldName := 'Nachname';
    StringField4.Size := 40;
    StringField5.SetParentComponent(xdsticket2);
    StringField5.Name := 'StringField5';
    StringField5.FieldName := 'Vorname';
    StringField5.Size := 40;
    StringField6.SetParentComponent(xdsticket2);
    StringField6.Name := 'StringField6';
    StringField6.FieldName := 'Email';
    StringField6.Size := 50;
    StringField7.SetParentComponent(xdsticket2);
    StringField7.Name := 'StringField7';
    StringField7.FieldName := 'SystemInfo';
    StringField7.Size := 255;
    StringField8.SetParentComponent(xdsticket2);
    StringField8.Name := 'StringField8';
    StringField8.FieldName := 'Loesung';
    StringField8.Size := 255;
    StringField9.SetParentComponent(xdsticket2);
    StringField9.Name := 'StringField9';
    StringField9.FieldName := 'Protokoll';
    StringField9.Size := 255;
    IntegerField2.SetParentComponent(xdsticket2);
    IntegerField2.Name := 'IntegerField2';
    IntegerField2.FieldName := 'ZeitaufwandMinuten';
    IntegerField3.SetParentComponent(xdsticket2);
    IntegerField3.Name := 'IntegerField3';
    IntegerField3.FieldName := 'AbzurechnendeMinuten';
    IntegerField4.SetParentComponent(xdsticket2);
    IntegerField4.Name := 'IntegerField4';
    IntegerField4.FieldName := 'AbgerechneteMinuten';
    DateTimeField4.SetParentComponent(xdsticket2);
    DateTimeField4.Name := 'DateTimeField4';
    DateTimeField4.FieldName := 'BenachrichtigungNEU';
    DateTimeField5.SetParentComponent(xdsticket2);
    DateTimeField5.Name := 'DateTimeField5';
    DateTimeField5.FieldName := 'BenachrichtigungLoesung';
    StringField10.SetParentComponent(xdsticket2);
    StringField10.Name := 'StringField10';
    StringField10.FieldName := 'InterneBemerkung';
    StringField10.Size := 255;
    IntegerField5.SetParentComponent(xdsticket2);
    IntegerField5.Name := 'IntegerField5';
    IntegerField5.FieldName := 'LoesungInfoSenden';
    StringField11.SetParentComponent(xdsticket2);
    StringField11.Name := 'StringField11';
    StringField11.FieldName := 'Kontaktperson';
    StringField11.Size := 100;
    StringField12.SetParentComponent(xdsticket2);
    StringField12.Name := 'StringField12';
    StringField12.FieldName := 'ErreichbarkeitTelefon';
    StringField12.Size := 100;
    StringField13.SetParentComponent(xdsticket2);
    StringField13.Name := 'StringField13';
    StringField13.FieldName := 'ErreichbarkeitWann';
    StringField13.Size := 100;
    xdsKontosaldo.SetParentComponent(Self);
    xdsKontosaldo.Name := 'xdsKontosaldo';
    xdsKontosaldo.AfterOpen := xdsKontosaldoAfterOpen;
    xdsKontosaldo.EntitySetName := 'ITS_Kontosalden';
    xdsKontosaldo.Connection := DM2.XDataWebConnection1;
    xdsKontosaldo.Left := 32;
    xdsKontosaldo.Top := 416;
    xdsKontosaldoKundennummer.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoKundennummer.Name := 'xdsKontosaldoKundennummer';
    xdsKontosaldoKundennummer.FieldName := 'Kundennummer';
    xdsKontosaldoKundennummer.Required := True;
    xdsKontosaldoKundennummer.Size := 13;
    xdsKontosaldoZeitaufwand.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoZeitaufwand.Name := 'xdsKontosaldoZeitaufwand';
    xdsKontosaldoZeitaufwand.FieldName := 'Zeitaufwand';
    xdsKontosaldoAbzurechnen.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoAbzurechnen.Name := 'xdsKontosaldoAbzurechnen';
    xdsKontosaldoAbzurechnen.FieldName := 'Abzurechnen';
    xdsKontosaldoGutschrift.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoGutschrift.Name := 'xdsKontosaldoGutschrift';
    xdsKontosaldoGutschrift.FieldName := 'Gutschrift';
    xdsKontosaldoAbzug.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoAbzug.Name := 'xdsKontosaldoAbzug';
    xdsKontosaldoAbzug.FieldName := 'Abzug';
    xdsKontosaldoSaldo.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoSaldo.Name := 'xdsKontosaldoSaldo';
    xdsKontosaldoSaldo.FieldName := 'Saldo';
    xdsKontosaldoBetrag.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoBetrag.Name := 'xdsKontosaldoBetrag';
    xdsKontosaldoBetrag.FieldName := 'Betrag';
    xdsKontosaldoMinutenpreis.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoMinutenpreis.Name := 'xdsKontosaldoMinutenpreis';
    xdsKontosaldoMinutenpreis.FieldName := 'Minutenpreis';
    xdsKontosaldoSRestguthaben.SetParentComponent(xdsKontosaldo);
    xdsKontosaldoSRestguthaben.Name := 'xdsKontosaldoSRestguthaben';
    xdsKontosaldoSRestguthaben.FieldName := 'SRestguthaben';
  finally
    TC.AfterLoadDFMValues;
    WebFilePicker1.AfterLoadDFMValues;
    WebFilePicker2.AfterLoadDFMValues;
    WebFilePicker3.AfterLoadDFMValues;
    xdsTicket.AfterLoadDFMValues;
    xdsTicketKundennummer.AfterLoadDFMValues;
    xdsTicketProdukt.AfterLoadDFMValues;
    xdsTicketKategorie.AfterLoadDFMValues;
    xdsTicketPrioritaet.AfterLoadDFMValues;
    xdsTicketStatus.AfterLoadDFMValues;
    xdsTicketID.AfterLoadDFMValues;
    xdsTicketErstelltAm.AfterLoadDFMValues;
    xdsTicketBetreff.AfterLoadDFMValues;
    xdsTicketBeschreibung.AfterLoadDFMValues;
    xdsTicketAbrechnungsbetrag.AfterLoadDFMValues;
    xdsTicketAbrechnungRechnungsnummer.AfterLoadDFMValues;
    xdsTicketAberechnetAm.AfterLoadDFMValues;
    xdsTicketErledigtAm.AfterLoadDFMValues;
    xdsTicketNachname.AfterLoadDFMValues;
    xdsTicketVorname.AfterLoadDFMValues;
    xdsTicketEmail.AfterLoadDFMValues;
    xdsTicketSystemInfo.AfterLoadDFMValues;
    xdsTicketLoesung.AfterLoadDFMValues;
    xdsTicketProtokoll.AfterLoadDFMValues;
    xdsTicketZeitaufwandMinuten.AfterLoadDFMValues;
    xdsTicketAbzurechnendeMinuten.AfterLoadDFMValues;
    xdsTicketAbgerechneteMinuten.AfterLoadDFMValues;
    xdsTicketBenachrichtigungNEU.AfterLoadDFMValues;
    xdsTicketBenachrichtigungLoesung.AfterLoadDFMValues;
    xdsTicketInterneBemerkung.AfterLoadDFMValues;
    xdsTicketLoesungInfoSenden.AfterLoadDFMValues;
    xdsTicketKontaktperson.AfterLoadDFMValues;
    xdsTicketErreichbarkeitTelefon.AfterLoadDFMValues;
    xdsTicketErreichbarkeitWann.AfterLoadDFMValues;
    xdsProdukte.AfterLoadDFMValues;
    xdsProdukteProdukt.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenGruppeKunden.AfterLoadDFMValues;
    xdsKundendatenGruppeLieferanten.AfterLoadDFMValues;
    xdsKundendatenGruppeSonstige.AfterLoadDFMValues;
    xdsKundendatenGruppeNichtkunden.AfterLoadDFMValues;
    xdsKundendatenKontaktgruppe.AfterLoadDFMValues;
    xdsKundendatenNachname.AfterLoadDFMValues;
    xdsKundendatenVorname.AfterLoadDFMValues;
    xdsKundendatenAdresszeile2.AfterLoadDFMValues;
    xdsKundendatenAdresszeile3.AfterLoadDFMValues;
    xdsKundendatenStrasse.AfterLoadDFMValues;
    xdsKundendatenPostleitzahl.AfterLoadDFMValues;
    xdsKundendatenOrt.AfterLoadDFMValues;
    xdsKundendatenLaenderkuerzel.AfterLoadDFMValues;
    xdsKundendatenLand.AfterLoadDFMValues;
    xdsKundendatenLaenderkennzeichen.AfterLoadDFMValues;
    xdsKundendatenAdressanrede.AfterLoadDFMValues;
    xdsKundendatenBriefanrede1.AfterLoadDFMValues;
    xdsKundendatenAdresseBild.AfterLoadDFMValues;
    xdsKundendatenLieferanschrift.AfterLoadDFMValues;
    xdsKundendatenTelefonNummer.AfterLoadDFMValues;
    xdsKundendatenTelefaxNummer.AfterLoadDFMValues;
    xdsKundendatenMobilTelefon.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenInternet.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenZahlungsbedingung.AfterLoadDFMValues;
    xdsKundendatenTransportbedingung.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsKundendatenTelefonAlternativ.AfterLoadDFMValues;
    xdsKundendatenTitel.AfterLoadDFMValues;
    xdsKundendatenKundenklasseFarbe.AfterLoadDFMValues;
    xdsKundendatenRechnungEmail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
    xdsKundendatenBesteuerungKey.AfterLoadDFMValues;
    xdsKundendatenAuftraegeJahr.AfterLoadDFMValues;
    xdsKundendatenAuftraegeVorjahr.AfterLoadDFMValues;
    xdsKundendatenLieferadresseID.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    xdsKundendatenKontaktverbund.AfterLoadDFMValues;
    xdsKundendatenHinweis.AfterLoadDFMValues;
    xdsKundendatenLatitude.AfterLoadDFMValues;
    xdsKundendatenLongitude.AfterLoadDFMValues;
    xdsKundendatenkmLuftlinie.AfterLoadDFMValues;
    xdsKundendatenGoogleID.AfterLoadDFMValues;
    xdsKundendatenGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsKundendatenBundesland.AfterLoadDFMValues;
    xdsKundendatenRegion.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenz.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenzVom.AfterLoadDFMValues;
    xdsKundendatenLastschriftArt.AfterLoadDFMValues;
    xdsKundendatenMahnsperre.AfterLoadDFMValues;
    xdsKundendatenSuchbegriff.AfterLoadDFMValues;
    xdsKundendatenLieferanschriftDaten.AfterLoadDFMValues;
    xdsKundendatenExportKasse.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsKundendatenPseudonymisiert.AfterLoadDFMValues;
    xdsKundendatenLoginAktiv.AfterLoadDFMValues;
    xdsKundendatenSonstigeDaten.AfterLoadDFMValues;
    xdsStatus.AfterLoadDFMValues;
    xdsStatusStatus.AfterLoadDFMValues;
    xdsKategorie.AfterLoadDFMValues;
    xdsKategorieKategorie.AfterLoadDFMValues;
    xdsprioritaet.AfterLoadDFMValues;
    xdsprioritaetPrioritaet.AfterLoadDFMValues;
    xdsprioritaetPrioText.AfterLoadDFMValues;
    xdsprioritaetPrioFarbe.AfterLoadDFMValues;
    xdsTicketDateien.AfterLoadDFMValues;
    xdsTicketDateienTicketID.AfterLoadDFMValues;
    xdsTicketDateienID.AfterLoadDFMValues;
    xdsTicketDateienDatumUhrzeit.AfterLoadDFMValues;
    xdsTicketDateienFuerLoesung.AfterLoadDFMValues;
    xdsTicketDateienDateiMime.AfterLoadDFMValues;
    xdsTicketDateienDateiName.AfterLoadDFMValues;
    xdsTicketDateienDateiGroesse.AfterLoadDFMValues;
    xdsTicketDateienDateiInhaltText.AfterLoadDFMValues;
    xdsticket2.AfterLoadDFMValues;
    XDataWebEntityField1.AfterLoadDFMValues;
    XDataWebEntityField2.AfterLoadDFMValues;
    XDataWebEntityField3.AfterLoadDFMValues;
    XDataWebEntityField4.AfterLoadDFMValues;
    XDataWebEntityField5.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    DateTimeField1.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    FloatField1.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    DateTimeField2.AfterLoadDFMValues;
    DateTimeField3.AfterLoadDFMValues;
    StringField4.AfterLoadDFMValues;
    StringField5.AfterLoadDFMValues;
    StringField6.AfterLoadDFMValues;
    StringField7.AfterLoadDFMValues;
    StringField8.AfterLoadDFMValues;
    StringField9.AfterLoadDFMValues;
    IntegerField2.AfterLoadDFMValues;
    IntegerField3.AfterLoadDFMValues;
    IntegerField4.AfterLoadDFMValues;
    DateTimeField4.AfterLoadDFMValues;
    DateTimeField5.AfterLoadDFMValues;
    StringField10.AfterLoadDFMValues;
    IntegerField5.AfterLoadDFMValues;
    StringField11.AfterLoadDFMValues;
    StringField12.AfterLoadDFMValues;
    StringField13.AfterLoadDFMValues;
    xdsKontosaldo.AfterLoadDFMValues;
    xdsKontosaldoKundennummer.AfterLoadDFMValues;
    xdsKontosaldoZeitaufwand.AfterLoadDFMValues;
    xdsKontosaldoAbzurechnen.AfterLoadDFMValues;
    xdsKontosaldoGutschrift.AfterLoadDFMValues;
    xdsKontosaldoAbzug.AfterLoadDFMValues;
    xdsKontosaldoSaldo.AfterLoadDFMValues;
    xdsKontosaldoBetrag.AfterLoadDFMValues;
    xdsKontosaldoMinutenpreis.AfterLoadDFMValues;
    xdsKontosaldoSRestguthaben.AfterLoadDFMValues;
  end;
end;

end.